import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Courses() {
  return <section id="courses" className="py-32 bg-surface" data-id="element-48">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16 items-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-50">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-51">
            Стань майстром
          </h2>
          <div className="w-12 h-1 bg-ink rounded-full mb-8" data-id="element-52"></div>

          <p className="text-muted font-normal text-lg leading-relaxed mb-10" data-id="element-53">
            Авторські курси для початківців та майстрів, які хочуть підвищити
            свою кваліфікацію. Навчання проходить у міні-групах, що гарантує
            індивідуальний підхід до кожного учня.
          </p>

          <ul className="space-y-5 mb-12" data-id="element-54">
            {['80% практичних занять на моделях', 'Надання всіх необхідних інструментів та матеріалів', 'Сертифікат після успішного завершення', 'Підтримка та консультації після курсу'].map((item, i) => <li key={i} className="flex items-start" data-id="element-55">
                <div className="bg-white p-1 rounded-full border border-line mr-4 mt-0.5 shadow-sm" data-id="element-56">
                  <Check className="text-ink flex-shrink-0" size={14} strokeWidth={3} data-id="element-57" />
                </div>
                <span className="text-ink font-medium text-base" data-id="element-58">{item}</span>
              </li>)}
          </ul>

          <a href="#contact" className="inline-block px-8 py-4 bg-ink text-white text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-59">
            Записатися на курс
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative h-[500px] md:h-[600px] group" data-id="element-60">
          <div className="w-full h-full bg-white rounded-[2.5rem] border border-line shadow-2xl flex items-center justify-center overflow-hidden transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-61">
            <div className="text-center" data-id="element-62">
              <div className="w-16 h-16 mx-auto mb-4 border border-line rounded-full flex items-center justify-center bg-surface" data-id="element-63">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted" data-id="element-64">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-65"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5" data-id="element-66"></circle>
                  <polyline points="21 15 16 10 5 21" data-id="element-67"></polyline>
                </svg>
              </div>
              <p className="text-sm text-muted font-medium tracking-widest uppercase" data-id="element-68">
                Фото процесу навчання
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}